<template>
    <div>
        <action-row>
            <el-button type="success"
                @click="beginDown()">
                开始预加载
            </el-button>
            <!-- <my-btn type="new" @click="YzWzx()">验证文件完整性</my-btn> -->
        </action-row>
        <my-tag type="danger" >
            特别提醒：1、状态为“需重新下载”的,必须点击“单独加载”进行重新加载。
            2、预加载过程中，必须等一个加载完毕后才能进行下一个。
            3、状态为"完成√"，为文件预加载完成。
        </my-tag> 
        <my-table :data="tableData">
            <el-table-column label="投标人名称(编码)" prop="bdname">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.tbdwname}}
                    </div>
                    <div>
                        {{scope.row.tbdwcode}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="文件大小" prop="pdfLength"></el-table-column>
            <el-table-column label="状态(缓存文件完整性)" prop="htgsj">
                <template slot-scope="scope">
                    <my-tag type="danger" v-if="progress[scope.$index].wanzheng===false">
                        需重新加载
                    </my-tag>
                    <my-tag type="success" v-if="progress[scope.$index].wanzheng===true">
                        完成√
                    </my-tag>
                </template>
            </el-table-column>
            <el-table-column label="预加载" prop="e_gzdw">
                <template slot-scope="scope">
                    完成进度
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="progress[scope.$index].percent"></el-progress>
                </template>
            </el-table-column>
            <el-table-column label="单独加载" >
                 <template slot-scope="scope">
                    <el-button type="text"
                    @click="downSingle(scope.row)">
                        单独预加载
                    </el-button>
                </template> 
            </el-table-column>
        </my-table>
        <object 
            id="certMgrObj"
            classid="CLSID:59B3BFD5-6CC5-4FFA-90E8-C1E5AFCB42E9" 
            width="1"
            height="1" viewastext
        ></object>
    </div> 
</template>

<script>
// import FORM_PAGE_MIXIN from '@views/mixins/form-page'
// import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

export default {
    // mixins: [ FORM_PAGE_MIXIN, LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN ],
    components: {},
    props:{
        data: {
            type: Object,
            default: () => (
                { }
            )
        }
    },
    data() {
        return {
            tableData:[],
            serverUrl:'',
          
            Util:{

            },
            sum:0,
            // certMgrObj:''
            progress:[ ]     
        }
    },
    computed: {
        query() {
            return this.getQuery()
        }
    },
    methods: {
        getClientSha1(filePathName) {
            var u = certMgrObj.Util;
            return  this.Util.HashFile(filePathName,1,function (){return true});
        },
        checkPdfExit(downUrl,tbdwcode,pdfSha1) {
             try {
            downUrl=downUrl.replace(/\\/g,'/');
            certMgrObj.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
			var u = certMgrObj.Util;	
		    var strs = downUrl.split("/"); 
            var fileName = strs[strs.length-1];
            var folderName = strs[strs.length-4]+"\\"+strs[strs.length-3]+"\\"+strs[strs.length-2];
            var filePath = this.Util.GetFolderPath(5) +"hbidding"+"\\"+folderName;
            var file = filePath+"\\"+fileName; 
            if (this.Util.FileExists(file))//存在显示
            {
              if(this.getClientSha1(file)==pdfSha1)
              {      
                for(var i=0;i<this.progress.length;i++) {
                    if(this.progress[i].tbdwcode==tbdwcode) {
                        this.progress[i].wanzheng= true
                    }
                }
              }
              else
              {
            	for(var i=0;i<this.progress.length;i++) {
                    if(this.progress[i].tbdwcode==tbdwcode) {
                        this.progress[i].wanzheng= false
                    }
                }
              }
              return "";
            }  
            else{//不存在下载
            	return file;
            } 	
            }catch (e) {
				//alert("失败" + e.message)
			}
        },
        YzWzx(){
            for(var m = 0; m < this.tableData.length; m++)
                { 
                   this.checkPdfExit(this.serverUrl+this.tableData[m].pdfFile,this.tableData[m].tbdwcode,this.tableData[m].pdfSha1);
                } 
        },
        downPdf(downUrl,tbdwcode,pdfSha1,bDown) {
           
            var that = this;
            try {
				downUrl = downUrl.replace(/\\/g,'/');
				certMgrObj.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
				var u = certMgrObj.Util;
                // console.log(u)
				var strs = downUrl.split("/");
                var fileName='';
                fileName = strs[strs.length-1];
                var folderName = strs[strs.length-4]+"\\"+strs[strs.length-3]+"\\"+strs[strs.length-2];
                var filePath = this.Util.GetFolderPath(5) +"hbidding"+"\\"+folderName;
                this.Util.CreateDir(filePath) ; 
                var file = filePath+"\\"+fileName;
                //单个下载
                if(bDown) {
                    this.Util.Download( downUrl, file, OpCallback);
                    return;
                }
                //存在显示
                if (this.Util.FileExists(file)&&this.getClientSha1(file)==pdfSha1 ) {
                    for(var i=0;i<that.progress.length;i++) {
                                if(that.progress[i].tbdwcode==tbdwcode) {
                                    that.progress[i].wanzheng= true
                                }
                            }
                    for(var i=0;i<that.progress.length;i++) {
                        if(that.progress[i].tbdwcode==tbdwcode) {
                            that.progress[i].percent= 100 
                        }
                    } 
                  
                } else{//不存在下载
              
                    this.Util.Download( downUrl, file, OpCallback);
                } 	 
                var allCount = 0;
			    function OpCallback (message, value) {
					 if (message == 1) {
                    
						if (value == 0) {
							//alert("开始操作,未知文件长度");
						} else {
							allCount = value;
						}
					} else if (message == 2) {
               
                        for(var i=0;i<that.progress.length;i++) {
                            if(that.progress[i].tbdwcode==tbdwcode) {
                                that.progress[i].percent= Math.round(parseFloat(value / allCount) * 100); 
                            }
                        }
					} else {
              
                         for(var i=0;i<that.progress.length;i++) {
                            if(that.progress[i].tbdwcode==tbdwcode) {
                                that.progress[i].percent= 100 
                                that.progress[i].wanzheng= true
                            }
                        }
			            that.YzWzx();
					}
                        //     console.log('getprogress')
                        // that.$emit('getprogress',that.progress)
					return true; 
            
	    		}
			} catch (e) {
				//alert("失败" + e.message)
			}
        },
        downSingle(row) {
            if (!row.pdfFile||!row.pdfSha1){
                ShowMsgBox('该文件存在异常','error')
            }else {
                this.downPdf(this.serverUrl+row.pdfFile,row.tbdwcode,row.pdfSha1,true)
            }
        },
        beginDown() {
            var errorFileList = [];
            for(var m = 0; m < this.tableData.length; m++){ 
                var theFileInfo = this.tableData[m];
                if (!theFileInfo.pdfFile||!theFileInfo.pdfSha1){
                    errorFileList.push(theFileInfo);
                }else {
                    this.downPdf(theFileInfo.pdfFile,theFileInfo.tbdwcode,theFileInfo.pdfSha1,false);
                } 
            }
            if (errorFileList.length>0){
                ShowMsgBox('该标段下有'+errorFileList.length+'个文件有异常','error')
                return
            }
            if(this.progress.length>=1) {
                ShowMsg('该标段预加载完成','success')
            }else {
                ShowMsg('无可加载的文件','warning')
            }        
        }                    
    },            
    created() {
        this.Util = certMgrObj.Util        
        // this.progress = this.data.progress
        this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/pwtbwjyjz.json`, 
        { bdcode:this.data.bdcodejm}
        , data => {
            this.tableData=data.listData
            for(var n=0;n < this.tableData.length;n++) {
                this.progress.push({tbdwcode:this.tableData[n].tbdwcode,percent:0,wanzheng:''})
            }
            for(var m = 0; m < this.tableData.length; m++){                               
            	this.checkPdfExit(this.serverUrl+this.tableData[m].pdfFile,this.tableData[m].tbdwcode,this.tableData[m].pdfSha1);
            }  
            for(var i=0;i<this.progress.length;i++) {
                if(this.progress[i].wanzheng==true) {
                    console.log(1)
                    this.progress[i].percent = 100
                }
            }
        });
    },
}
</script>

<style scoped lang="scss">

</style>
